import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF, FaLinkedin } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/ThisMuch4" target="_blank" rel='noreferrer'><BsTwitter /></a> 
    </div>
    <div>
      <a href="https://www.facebook.com/jasur.sadiev.7/" target="_blank" rel='noreferrer'><FaFacebookF /></a>
    </div>
    <div>
      <a href="https://www.instagram.com/" target="_blank" rel='noreferrer'><BsInstagram /></a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/jasur-sadiev-7104321b2/" target="_blank" rel='noreferrer'><FaLinkedin /></a>
    </div>
  </div>
);

export default SocialMedia;
